import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import React from 'react'

/**
 *  VideoControllers tag abstraction.
 */
class VideoControllers extends React.Component {
  /**
   *  render videos controllers
   */
  renderControllers() {
    const { playPause, pause, rewind, time, videoOptions, setTimePoint } = this.props
    const remainingMinutes =
      Math.trunc(time.currentTime / 60) < 10
        ? ['0', Math.trunc(time.currentTime / 60)].join('').trim()
        : Math.trunc(time.currentTime / 60)
    const remainingSeconds =
      Math.trunc(time.currentTime % 60) < 10
        ? ['0', Math.trunc(time.currentTime % 60)].join('').trim()
        : Math.trunc(time.currentTime % 60)
    const totalMinutes =
      Math.trunc(time.duration / 60) < 10
        ? ['0', Math.trunc(time.duration / 60)].join('').trim()
        : Math.trunc(time.duration / 60)
    const totalSeconds =
      Math.trunc(time.duration % 60) < 10
        ? ['0', Math.trunc(time.duration % 60)].join('').trim()
        : Math.trunc(time.duration % 60)
    let bufferBar = this.renderBufferBar()
    let buffer = document.getElementById('buffer')

    return (
      <div className="video--controls">
        {videoOptions.bar ? (
          <div
            id="buffer"
            className="video--controls__bar"
            onClick={(mouseEvent) => {
              setTimePoint(mouseEvent.clientX, buffer.offsetWidth, buffer.offsetLeft)
            }}
          >
            {bufferBar}
          </div>
        ) : (
          false
        )}
        <div className="video--controls__actions">
          <div className="video--controls__buttons">
            {videoOptions.pause ? (
              <div
                className={playPause ? 'icon-play' : 'icon-pause'}
                onClick={() => {
                  pause()
                }}
              ></div>
            ) : null}
            {videoOptions.rewind ? (
              <div
                className="icon-rewind"
                onClick={() => {
                  rewind()
                }}
              >
                <span>15</span>
              </div>
            ) : null}
          </div>
          <div className="video--time">
            <span className="time">
              {remainingMinutes}:{remainingSeconds}
            </span>
            <span className="duration">
              {totalMinutes}:{totalSeconds}
            </span>
          </div>
        </div>
      </div>
    )
  }
  /**
   *  render ada's videos controllers
   */
  renderDefaultControllers() {
    const { playPause, skip, pause } = this.props

    return (
      <div
        style={{
          position: 'absolute',
          top: '5%',
          right: '5%',
          textAlign: 'right',
          cursor: 'pointer',
          zIndex: '2',
        }}
      >
        <div
          onClick={() => {
            skip()
          }}
        >
          <FormattedMessage id="video.skip" />
        </div>
        <div
          onClick={() => {
            pause()
          }}
        >
          <FormattedMessage id={playPause ? 'video.play' : 'video.pause'} />
        </div>
      </div>
    )
  }

  renderBufferBar() {
    const { time } = this.props
    const barPercentage = Math.floor((time.currentTime * 100) / time.duration)
    return <div className="video--controls__progress" style={{ width: barPercentage + '%' }}></div>
  }
  /**
   *  Render component
   */
  render() {
    const { videoOptions } = this.props
    if (videoOptions.classController === 'default-controllers') {
      return this.renderDefaultControllers()
    }
    return this.renderControllers()
  }
}

VideoControllers.propTypes = {
  playPause: PropTypes.bool,
  videoOptions: PropTypes.object,
  time: PropTypes.object,
  pause: PropTypes.func,
  rewind: PropTypes.func,
  skip: PropTypes.func,
  setTimePoint: PropTypes.func,
}

export default connect()(VideoControllers)
